import React from "react";
import FormLayout from "./FormLayout";
import Forgotpassword from "./WithUi/Forgotpassword";

function ForgotPassword() {
  return (
    <FormLayout >
      <Forgotpassword />
    </FormLayout>
  );
}
export default ForgotPassword;
